<div
	class="container"
	(click)="onClick()"
	(keydown.enter)="onClick()"
	(keydown.space)="$event.preventDefault(); onClick()"
	[tabIndex]="(shouldDisable$  | async)  !== true && label !== 'Get Started' ? -1 : 0"
	role="button"
	[attr.aria-current]="isCurrentStep ? 'step' : null"
	[matTooltip]="(shouldDisable$  | async) !== true && label !== 'Get Started' ? 'Cannot proceed until you select a division.' : ''"
>
	<div
		class="step"
		[class.pointer]="(shouldDisable$  | async) === true"
		[ngClass]="{
			'current-step': isCurrentStep
		}"
	>
		{{ step + 1 }}
	</div>
	<div
		class="label"
		[class.pointer]="(shouldDisable$  | async) === true"
		[ngClass]="{
			'current-step': isCurrentStep
		}"
	>
		{{ label }}
	</div>
</div>
